import React from 'react';
import './Button.css';

export default function KButton({ hide = false, onClick }) {
  const isMac = navigator.platform.toUpperCase().includes('MAC');

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      id='search-button'
      type='button'
      onClick={handleClick}
      className='search-bar'
      style={{ display: hide ? 'none' : 'flex' }}
    >
      <div className='search-bar-icon search-bar-icon-medium'>
        <span>{isMac ? '⌘' : 'Ctrl +'}</span>
      </div>
      <div className='search-bar-key search-bar-key-medium'>K</div>
    </button>
  );
}
